import QueryBuilder from "../ctrl/QueryBuilder.js";
import LayerResults from "./components/LayerResults";
import QueryResults from "./components/QueryResults";
import QueryResults_Fototeca from "./components/QueryResults_Fototeca";
import ResultsProvider from "./components/ResultsProvider";
import * as Solr from "../../../3x1010/Solr.js";
import FilmografiaDetails from "./components/FilmografiaDetails.js";
import QueryResults_ArchelogiaDelCinema from "./components/QueryResults_ArchelogiaDelCinema";
import QueryResults_Apparecchi from "./components/QueryResults_Apparecchi";
import QueryResults_Archivi from "./components/QueryResults_Archivi";
import QueryResults_Manifesti from "./components/QueryResults_Manifesti";
import QueryResults_Memorabilia from "./components/QueryResults_Memorabilia";
import QueryResults_Miscellanea from "./components/QueryResults_Miscellanea";
import QueryResults_Cineteca from "./components/QueryResults_Cineteca";
import QueryResults_Filmografia from "./components/QueryResults_Filmografia.js";

export default class ResultViewer {
  constructor() {
    this.layerResults = null;
    this.paths = [];
  }

  search(terms, collection, field = null) {
    let query;
    let type;
    if (field) {
      type = ResultsProvider.SEARCH_TYPE_ONFIELD;
      query = {
        FieldPath: field,
        Value: terms,
        Compare: ResultsProvider.SEARCH_TYPE_ONFIELD_MODE,
        Occurency: "MUST",
      };
    } else {
      type = ResultsProvider.SEARCH_TYPE_FULLTEXT;
      query = {
        Value: terms,
        Compare: ResultsProvider.SEARCH_TYPE_FULLTEXT_MODE,
        Occurency: "MUST",
      };
    }

    const qb = new QueryBuilder(null, null, collection);
    qb.init();

    const q = query; //Solr.QueryWrapper.toJsonObject(query);

    // Esegue la query
    qb.query = q;

    this.layerResults = new LayerResults(this);
    this.layerResults.init();

    // Istanzia il results provider
    this.resultProvider = new ResultsProvider(qb, type);
    const tab = this.layerResults.addTab(false, "Risultati");

    this.createResults(qb, collection, tab, this.resultProvider);
  }

  searchAdvanced(qb) {
    // Crea il layer
    this.layerResults = new LayerResults(this);
    this.layerResults.init();

    // Istanzia il results provider
    const resultProvider = new ResultsProvider(qb, ResultsProvider.SEARCH_TYPE_ADVANCED);
    const tab = this.layerResults.addTab(false, "Risultati");
    this.createResults(qb, qb.collectionName, tab, resultProvider);
  }

  createResults(qb, collectionName, tab, resultProvider, payload) {
    if (resultProvider.type === ResultsProvider.SEARCH_TYPE_ADVANCED) {
      this.paths = this.extractPaths(qb.getQuery());
    } else if (resultProvider.type === ResultsProvider.SEARCH_TYPE_ONFIELD) {
      this.paths = [qb.getQuery().FieldPath];
    } else {
      this.paths = [];
    }
    // Qui deve istanziare la classe appropiata per visualizzare i risultati
    let result;
    if (collectionName == "FOTOTECA_coll") {
      result = new QueryResults_Fototeca(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "FILMOGRAFIA_coll") {
      result = new QueryResults_Filmografia(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "APPARECCHI_coll") {
      result = new QueryResults_Apparecchi(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "ARCHIVI_coll") {
      result = new QueryResults_Archivi(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "MANIFESTI_coll") {
      result = new QueryResults_Manifesti(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), payload ? payload.type : QueryResults_Manifesti.TYPE_CON_FILM, this.paths);
    } else if (collectionName == "MEMORABILIA_coll") {
      result = new QueryResults_Memorabilia(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), payload ? payload.type : QueryResults_Memorabilia.TYPE_CON_FILM, this.paths);
    } else if (collectionName == "MISCELLANEA_coll") {
      result = new QueryResults_Miscellanea(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "ARCHEOLOGIADELCINEMA_coll") {
      result = new QueryResults_ArchelogiaDelCinema(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), this.paths);
    } else if (collectionName == "CINETECA_coll") {
      result = new QueryResults_Cineteca(qb, collectionName, tab, resultProvider, this.resultsEventsHandler.bind(this), payload ? payload.type : QueryResults_Cineteca.TYPE_CAMPIONARI, this.paths);
    }
    result.init();
  }

  resultsEventsHandler(e) {
    if (e.type === QueryResults.EVENT_LOOK_FOR) {
      // Crea una nuova tab con un nuovo result
      const qb = new QueryBuilder(null, null, e.data.collectionName);
      qb.init();
      let q;
      let payload = null;
      //
      // FOTOTECA
      //
      // Crea una query molto custom in base al tipo di ricerca
      if (e.data.type === "FOTOTECA_identificazione_soggetto_SGTI") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Fototeca.QUERY_identificazione_soggetto_SGTI);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FOTOTECA_numero_catalogo_generale_NCTN") {
        // Fototeca numero catalogo generale
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Fototeca.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FOTOTECA_fotografo") {
        // Fototeca fotografo
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Fototeca.QUERY_fotografo);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // APPARECCHI
        //
      } else if (e.data.type === "APPARECCHI_numero_catalogo_generale_NCTN") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Apparecchi.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "APPARECCHI_definizione_oggetto_OGTD") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Apparecchi.QUERY_definizione_oggetto_OGTD);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "APPARECCHI_tipologia_OGTT") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Apparecchi.QUERY_tipologia_OGTT);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "APPARECCHI_identificazione_soggetto_SGTI") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Apparecchi.QUERY_identificazione_soggetto_SGTI);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "APPARECCHI_autore") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Apparecchi.QUERY_autore);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // ARCHVI
        //
      } else if (e.data.type === "ARCHIVI_entities") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Archivi.QUERY_entities);
        q.Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "ARCHIVI_unita_di_descrizione_collegate") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Archivi.QUERY_unita_di_descrizione_collegate);
        q.Clauses[0].Clauses[0].Value = e.data.name;

        //
        // MANIFESTI
        //
        // Crea una query molto custom in base al tipo di ricerca
      } else if (e.data.type === "MANIFESTI_numero_catalogo_generale_NCTN") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Manifesti.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MANIFESTI_definizione_oggetto_OGTD") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Manifesti.QUERY_definizione_oggetto_OGTD);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MANIFESTI_autore") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Manifesti.QUERY_autore);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // MEMORABILIA
        //
        // Crea una query molto custom in base al tipo di ricerca
      } else if (e.data.type === "MEMORABILIA_numero_catalogo_generale_NCTN") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Memorabilia.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MEMORABILIA_definizione_oggetto_OGTD") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Memorabilia.QUERY_definizione_oggetto_OGTD);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MEMORABILIA_autore") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Memorabilia.QUERY_autore);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // MISCELLANEA
        //
      } else if (e.data.type === "MISCELLANEA_numero_catalogo_generale_NCTN") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Miscellanea.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MISCELLANEA_definizione_oggetto_OGTD") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Miscellanea.QUERY_definizione_oggetto_OGTD);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MISCELLANEA_tipologia_OGTT") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Miscellanea.QUERY_tipologia_OGTT);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MISCELLANEA_identificazione_soggetto_SGTI") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Miscellanea.QUERY_identificazione_soggetto_SGTI);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "MISCELLANEA_autore") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Miscellanea.QUERY_autore);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // ARCHEOLOGIA DEL CINEMA
        //
      } else if (e.data.type === "ARCHEOLOGIADELCINEMA_numero_catalogo_generale_NCTN") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_ArchelogiaDelCinema.QUERY_numero_catalogo_generale_NCTN);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "ARCHEOLOGIADELCINEMA_definizione_oggetto_OGTD") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_ArchelogiaDelCinema.QUERY_definizione_oggetto_OGTD);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "ARCHEOLOGIADELCINEMA_tipologia_OGTT") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_ArchelogiaDelCinema.QUERY_tipologia_OGTT);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "ARCHEOLOGIADELCINEMA_identificazione_soggetto_SGTI") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_ArchelogiaDelCinema.QUERY_identificazione_soggetto_SGTI);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "ARCHEOLOGIADELCINEMA_autore") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_ArchelogiaDelCinema.QUERY_autore);
        q.Clauses[0].Clauses[1].Value = e.data.name;

        //
        // CINETECA
        //
      } else if (e.data.type === "CINETECA_lingua_EDCL") {
        // Fototeca identificazione soggetto
        q = Solr.QueryWrapper.fromJsonObject(QueryResults_Cineteca.QUERY_lingua_EDCL);
        q.Clauses[0].Value = e.data.name;
        payload = {
          type: e.data.viewType,
        };
        //
        // FILMOGRAFIA
        //
      } else if (e.data.type === "FILMOGRAFIA_titolo") {
        // Filmografia titolo
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_titolo));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FILMOGRAFIA_regista") {
        // Filmografia regista
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_regista));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FILMOGRAFIA_interprete") {
        // Filmografia interprete
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_interprete));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FILMOGRAFIA_sceneggiatore") {
        // Filmografia sceneggiatore
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_sceneggiatore));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FILMOGRAFIA_scenografo") {
        // Filmografia scenografo
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_scenografo));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Clauses[0].Value = e.data.name;
      } else if (e.data.type === "FILMOGRAFIA_montatore") {
        // Filmografia montatore
        const json = JSON.parse(JSON.stringify(FilmografiaDetails.QUERY_FILMOGRAFIA_montatore));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Clauses[0].Clauses[0].Value = e.data.name;
        //
        // FILMOGRAFIA COLLECTION
        //
      } else if (e.data.type === "CFILMOGRAFIA_titolo") {
        // Filmografia titolo
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_titolo));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "CFILMOGRAFIA_regista") {
        // Filmografia regista
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_regista));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "CFILMOGRAFIA_interprete") {
        // Filmografia interprete
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_interprete));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "CFILMOGRAFIA_sceneggiatore") {
        // Filmografia sceneggiatore
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_sceneggiatore));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "CFILMOGRAFIA_scenografo") {
        // Filmografia scenografo
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_scenografo));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      } else if (e.data.type === "CFILMOGRAFIA_montatore") {
        // Filmografia montatore
        const json = JSON.parse(JSON.stringify(QueryResults_Filmografia.QUERY_FILMOGRAFIA_montatore));
        json.CollectionName = e.data.collectionName;
        q = Solr.QueryWrapper.fromJsonObject(json);
        q.Clauses[0].Value = e.data.name;
      }
      // Esegue la query
      qb.query = q;
      const tab = this.layerResults.addTab(true, e.data.name, e.data.context);
      const resultProvider = new ResultsProvider(qb, ResultsProvider.SEARCH_TYPE_ADVANCED);
      this.createResults(qb, e.data.collectionName, tab, resultProvider, payload);
    } else if (e.type === QueryResults.EVENT_OPEN_SCHEDA) {
      this.openScheda(e.data);
    }
  }

  extractPaths(data) {
    this.paths = new Set(); // Reset paths before starting
    this._extractPathsRecursive(data);
    return Array.from(this.paths).filter((path) => path !== "/"); // Exclude root path
  }

  _extractPathsRecursive(data) {
    // Se l'elemento è un oggetto, controlliamo se ha la proprietà '_path'
    if (typeof data === "object" && data !== null) {
      if (data.hasOwnProperty("_path") && data["_path"] !== "/") {
        this.paths.add(data["_path"]);
      }
      // Scorriamo tutte le chiavi dell'oggetto
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          if (typeof data[key] === "object") {
            this._extractPathsRecursive(data[key]);
          }
        }
      }
    }

    // Se l'elemento è un array, scorriamo ciascun elemento
    if (Array.isArray(data)) {
      data.forEach((item) => this._extractPathsRecursive(item));
    }
  }

  openScheda(data) {
    //console.log(data);
    if (data.type === QueryResults.SCHEDA_TYPE_ENITITA) {
      window.open("/solr/Detail/ENTITA_coll/" + data.id, "_blank");
      //document.location.href = "http://test.museocinema.it/solr/Detail/ENTITA_coll/" + data.id;
    } else if (data.type === QueryResults.SCHEDA_TYPE_FILM) {
      window.open("/solr/Detail/FILMOGRAFIA_coll/" + data.id, "_blank");
      //document.location.href = "http://test.museocinema.it/solr/Detail/FILMOGRAFIA_coll/" + data.id;
    } else if (data.type === QueryResults.SCHEDA_TYPE_COLLECTION) {
      window.open("/solr/Detail/" + data.collectionName + "/" + data.id, "_blank");
      //document.location.href = "http://test.museocinema.it/solr/Detail/" + data.collectionName + "/" + data.id;
    } else {
      alert("Tipo scheda ancora da implementare");
    }
  }
}
